<div class="menu-container">
  <div class="row">
      <div class="col-xl-5 col-lg-5">
        <div class="menu-content">
          <img [src]="objMegamenu.img.src" [alt]="objMegamenu.img.alt" height="230px" width="180" style="object-fit: cover;" class="img">
          <div class="menu-items">
            <div class="display-center-items">
              <app-icon
                [name]="objMegamenu.icon.appIconName"
                [size]="28"
                [color]="'medium-blue'"
                aria-hidden="true"
              />
              <a class="menu-title" [routerLink]="objMegamenu.product_title_left.path">
                {{objMegamenu.product_title_left.label}}</a>
            </div>
            <p class="menu-subtitle">{{ objMegamenu.product_subtitle_left }}</p>
            @for (link of objMegamenu.menu_link_product_left; track $index) {
            <li>
              <a [routerLink]="link.url">{{link.label}}</a>
            </li>
            }
            <div class="wrapper-see-all">
              <a [routerLink]="objMegamenu.link_see_all"
                class="free-link">Vedi tutti
                <app-icon
                [name]="'ArrowRight'"
                [size]="12"
                [color]="'medium-blue'"
                aria-hidden="true"
              /></a>
              @if(objMegamenu.faq_text) {
              <a [routerLink]="objMegamenu.faq_text?.path"
                 [queryParams]="{id: objMegamenu.faq_text.id}"
                class="free-link">{{objMegamenu?.faq_text?.label}}</a>
              }
            </div>

          </div>
        </div>
      </div>
      <div class="col-xl-7 col-lg-7 right-menu">
        <div class="row">
          @if(objMegamenu.menu_link_product_right.length > 0) {
            <div class="menu-items col-4">
            <h2 class="menu-title-right">{{objMegamenu.product_title_right}}</h2>
            @for (link of objMegamenu.menu_link_product_right; track $index) {
            <li>
              @if(link.url.includes('https')) {
              <a [routerLink]="['/']"
                (click)="navigateByUrl(link.url)">{{link.label}}</a>
              } @else {
              <a [routerLink]="link.url"
              >{{link.label}}</a>
              }
            </li>
            }
          </div>
          }

          @if(objMegamenu.product_title_right_optional.length > 0) {
            <div class="menu-items col-4">
            @if(objMegamenu.product_title_right_optional) {
              <h2 class="menu-title-right">{{objMegamenu.product_title_right_optional}}</h2>
            }
            @if(objMegamenu.menu_link_product_right_optional.length > 0) {
              @for (link of objMegamenu.menu_link_product_right_optional; track $index) {
                <li class="mt-2">
                  <a [routerLink]="link.url"
                  >{{link.label}}</a>
                </li>
              }

            }
          </div>
          }
          @if (objMegamenu.card) {
          <div [class]="['container-tipologia-link',
          objMegamenu.menu_link_product_right.length > 0 || objMegamenu.product_title_right_optional.length > 0 ? 'col-8' : 'col-12']">

                <div>
                  <h5 class="card-title">{{objMegamenu.card.title}}</h5>
                  <p class="card-p col-md-12">
                    {{objMegamenu.card.description}}
                  </p>
                  <div class="d-flex align-items-center">
                    @if(objMegamenu.card.find_outmore.path.includes('https')) {
                    <a (click)="navigateByUrl(objMegamenu.card.find_outmore.path)"
                       class="card-find-outmore">{{objMegamenu.card.find_outmore.label}}</a>
                    } @else {
                      <a  [routerLink]="objMegamenu.card.find_outmore.path"
                        class="card-find-outmore">{{objMegamenu.card.find_outmore.label}}</a>
                    }
                    <app-icon
                      [name]="'CaretRight'"
                      [size]="24"
                      [color]="'bright-red'"
                      aria-hidden="true"
                    />
                </div>
              </div>
              <div>
                <img class="img-right" [src]="objMegamenu.card.img_right.src" [alt]="objMegamenu.card.img_right.alt">
              </div>

            @if(objMegamenu.labelGoToPage) {
            <div class="d-flex justify-content-end" style="width: 85%; margin-bottom: 10px;">
              <a [routerLink]="objMegamenu.labelGoToPage.path"
                class="free-link">{{objMegamenu.labelGoToPage.label}}
                <app-icon
                  [name]="'ArrowRight'"
                  [size]="12"
                  [color]="'medium-blue'"
                  aria-hidden="true"
                /></a>
            </div>
            }
          </div>
          }
        </div>
        <hr>
        @if( objMegamenu.label_redirect?.label || objMegamenu.labelGoToPageOptional) {
        <div class="label-redirect justify-content-between">
          <a [routerLink]="objMegamenu?.label_redirect?.path"
             class="free-link">{{objMegamenu?.label_redirect?.label}}
            <app-icon
              [name]="'ArrowRight'"
              [size]="12"
              [color]="'medium-blue'"
              aria-hidden="true"
            /></a>

          @if(objMegamenu.labelGoToPageOptional) {
          <a [routerLink]="objMegamenu.labelGoToPageOptional.path"
            class="free-link">{{objMegamenu.labelGoToPageOptional.label}}
            <app-icon
              [name]="'ArrowRight'"
              [size]="12"
              [color]="'medium-blue'"
              aria-hidden="true"
            /></a>
          }
          <a [routerLink]="objMegamenu.link_see_all"
             class="free-link">Vedi
                tutti
            <app-icon
              [name]="'ArrowRight'"
              [size]="12"
              [color]="'medium-blue'"
              aria-hidden="true"
            /></a>
        </div>
        }
      </div>
    </div>
</div>
